import { CollapsableGroup } from '@/module/AnnualReport/components/CollapsableGroup';
import { Article } from '@/module/Author/Article';
import { ArticleValidationAction } from '@/module/Author/Article/Validation/ArticleValidationAction';
import { ArticleCard } from '@/module/Author/Article/components/Card/ArticleCard';

interface CollapsableArticleProps {
  title: string;
  articles: Article[];
}

export function CollapsableArticle({ title, articles }: CollapsableArticleProps) {
  return (
    <CollapsableGroup
      title={title}
      items={articles}
      renderValidation={article => (
        <ArticleValidationAction
          variant="compact"
          articleId={article.id}
        />
      )}
      renderItem={article => (
        <ArticleCard
          article={article}
          onClick={() => window.open(`/author/article/${article.id}`)}
        />
      )}
    />
  );
}
